import { FormInput } from "@Rolec-Services/rolec-ui";
import { useTranslation } from "react-i18next";
import { StepProps } from "~/components/organisms/step";
import { ContactFields } from "../contact-fields";

export function Installer({ control }: { control: StepProps["control"] }) {
  const { t } = useTranslation();
  return (
    <>
      <ContactFields
        name="installation.installer"
        control={control}
        nameLabel="Installer Name"
        telephoneLabel="Installer Telephone"
        emailLabel="Installer Email"
      />

      <FormInput
        control={control}
        name="installation.notes"
        label={t("Installation Notes (optional)")}
      />
    </>
  );
}
